import * as yup from "yup";

const guestsValidationSchema = yup.object().shape({
    adults: yup
        .number()
        .positive('Deve essere un numero positivo')
        .integer('Deve essere un numero intero')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
    children: yup
        .number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
    petsNumber: yup
        .number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .max(5, 'Deve essere minore o uguale a 5')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
});

export default guestsValidationSchema;